/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AgentPollingPrincipal = {
  /**
   * Human-readable name of the agent identity.
   */
  displayName: string;
  /**
   * Principal URN of the agent identity, for example `agent:<uuid>`.
   */
  urn: string;
};

/** @internal */
export const AgentPollingPrincipal$inboundSchema: z.ZodMiniType<
  AgentPollingPrincipal,
  unknown
> = z.pipe(
  z.object({
    display_name: z.string(),
    urn: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "display_name": "displayName",
    });
  }),
);

export function agentPollingPrincipalFromJSON(
  jsonString: string,
): SafeParseResult<AgentPollingPrincipal, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AgentPollingPrincipal$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AgentPollingPrincipal' from JSON`,
  );
}
